<template>
  <vx-card class="mt-2 pagebreak-inside-avoid">
    <div class="text-justify" v-html="contractText"></div>
    <div>
      {{
        proposalData.dadosAssociacao.cidade
          ? proposalData.dadosAssociacao.cidade
          : 'Belo Horizonte'
      }},
      {{ displayDate }}
    </div>

    <div
      :class="isPolicy ? 'flex justify-center' : 'grid grid-cols-3 gap-4'"
      class="p-5 mt-5"
    >
      <div
        :class="isPolicy ? 'w-1/4' : ''"
        class="flex justify-center items-center"
      >
        <img
          class="imagem"
          src="../../../assets/images/assinatura/assinatura.jpeg"
          width="100"
          height="100"
          alt="Assinatura da Seguradora"
        />
      </div>

      <div class="flex justify-center items-center" v-if="!isPolicy">
        <div
          class="imagem"
          style="margin-left: 15px; width: 100px; height: 100px"
        />
      </div>

      <div class="flex justify-center items-center" v-if="!isPolicy">
        <div
          class="imagem"
          style="margin-left: 15px; width: 100px; height: 100px"
        />
      </div>
    </div>

    <div :class="isPolicy ? 'flex justify-center' : 'grid grid-cols-3 gap-4'">
      <div
        :class="isPolicy ? 'w-1/4' : ''"
        class="flex flex-col justify-start items-center assinatura"
      >
        <p><b>BP SEGURADORA SA</b></p>
        <p><b>50.180.527/0001-13</b></p>
      </div>

      <div
        class="flex flex-col justify-start items-center text-center assinatura"
        v-if="!isPolicy"
      >
        <p>
          <b>{{
            quotationData.broker.corporateReason || proposalData.regional
          }}</b>
        </p>
        <p>
          <b>{{ proposalData.regionalCnpj || '-' }}</b>
        </p>
      </div>

      <div
        class="flex flex-col justify-start items-center assinatura"
        v-if="!isPolicy"
      >
        <p>
          <b>{{ proposalData.dadosCliente.associado }}</b>
        </p>
        <p>
          <b>{{ proposalData.dadosCliente.cpf || '-' }}</b>
        </p>
      </div>
    </div>

    <div class="mt-5 flex justify-end">
      <vs-button
        color="success"
        type="gradient"
        class="w-2/6 btn-print"
        @click="printPDF()"
      >
        Exportar PDF
      </vs-button>
    </div>
  </vx-card>
</template>

<script>
import functions from '../../../utils/functions';

export default {
  name: 'EndorsementContractSignatures',
  props: {
    isPolicy: {
      type: Boolean,
      required: true,
    },
    isQuotation: {
      type: Boolean,
      required: true,
    },
    contractText: {
      type: String,
      required: true,
      default: () => '',
    },
    quotationData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    proposalData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    previousPolicy: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      functions,
    };
  },
  methods: {
    printPDF() {
      window.print();
    },
  },
  computed: {
    displayDate() {
      let date;

      if (!this.isPolicy && this.isQuotation) {
        return this.proposalData.dataEmissao;
      } else if (!this.isPolicy && !this.isQuotation) {
        date = this.proposalData.proposalDate;
      } else if (!this.isPolicy) {
        date = this.previousPolicy.subscriptionDate;
      } else {
        date = this.proposalData.dataAdesao;
      }

      return functions.formataDataHoraPadraoBR(date, false);
    },
  },
};
</script>

<style scoped>
.assinatura {
  border-top: 0.1rem solid #626262;
  margin: 0 1rem 0 1rem;
  padding-top: 0.5rem;
}
</style>
